import { render } from "./ChiefModal.vue?vue&type=template&id=93d611fc"
import script from "./ChiefModal.vue?vue&type=script&lang=js"
export * from "./ChiefModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__